const validate = (value) => {
  let errors = null;
  if (!value) {
    errors = { text: 'Please add your Username' };
  }
  return errors;
};

export default validate;
